/**
 * Formats an ISO datetime string into a human-readable format
 * @param dateTime - ISO datetime string
 * @returns Formatted date string (e.g., "Mar 3, 2026, 10:30 AM")
 */
export const formatDateTime = (dateTime: string): string => {
  try {
    const date = new Date(dateTime);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return dateTime;
  }
};
